export const getLearningMonthsCount = (startDate: Date, endDate: Date): number => {
  return Math.round(
    (endDate.getDate() - startDate.getDate()) / 30 +
      endDate.getMonth() -
      startDate.getMonth() +
      12 * (endDate.getFullYear() - startDate.getFullYear())
  )
}
// https://stackoverflow.com/questions/2536379/difference-in-months-between-two-dates-in-javascript#:~:text=getFullYear()*12%20%2B%20past_date.,two%20dates%2C%20ignoring%20the%20days.
